import 'swiper/css'
import 'swiper/css/pagination'
import { register } from 'swiper/element/bundle'
import { Pagination } from 'swiper/modules'
import 'swiper/swiper-bundle.css'
import type { SwiperOptions } from 'swiper/types'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { DefineComponentProps } from 'utils'
import type { CustomDefineComponent } from '../types/components'
import './Swiper.scss'

register()

type SwiperSlideProps = {
  children: CustomDefineComponent[]
}

interface SwiperProps extends Partial<SwiperOptions> {}

export const SwiperContainer = defineComponent<SwiperProps>({
  props: DefineComponentProps<SwiperProps>(['spaceBetween', 'slidesPerView', 'centeredSlides', 'initialSlide', 'centeredSlidesBounds', 'loop', 'pagination']),
  name: 'Swiper',
  setup(props, { slots }) {
    const swiperRef = ref()

    const getNotNullProps = () => {
      const newProps = Object.fromEntries(Object.entries(props).filter(([, value]) => value !== undefined && value !== null))
      return newProps
    }

    return () => {
      const defaultSlots: SwiperSlideProps[] = (slots.default?.() as unknown as SwiperSlideProps[]) || []
      const children = defaultSlots.map((item) => item.children).flat()

      return (
        <div class="swiper-layout">
          <div class={'swiper-container'} ref={swiperRef}>
            <Swiper modules={[Pagination]} pagination autoplay {...getNotNullProps()}>
              {children.map((item) => {
                return <SwiperSlide key={item.key}>{item}</SwiperSlide>
              })}
            </Swiper>
          </div>
        </div>
      )
    }
  },
})
